<template>
    <div>
        <public-menu></public-menu>
        <cate-search></cate-search>
        <bottom-nav></bottom-nav>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Catesearch from "@/components/shop/catesearch/catesearch"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../../components/Footer.vue"
export default{
    components:{
        'public-menu': Public_menu,
        'cate-search':Catesearch,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../../assets/css/style.css');
</style>


// WEBPACK FOOTER //
// src/views/shop/catesearch/catesearch.vue